import React, { useState, useContext } from 'react';
import axios from 'axios';
import Grid from '@mui/material/Grid';
import { Context } from '../../Content';
import CustomButton from '../components/CustomButton'
import InputTextBox from '../components/InputTextBox';
import InputNumberBox from '../components/InputNumberBox';
import { validateInputs } from '../components/validateInputs.js';
import { smoothScroll } from '../components/smoothScroll.js';

function AgentIndividualAddressInfoForm(props) {
  const [inputDataContext, isCorrectTransitionContext] = useContext(Context);
  const { inputData, setInputData } = inputDataContext;

  const [postalCode, setPostalCode] = useState(inputData['AgentIndividualAddressInfoForm'] === undefined ? '' : inputData['AgentIndividualAddressInfoForm'].postalCode);
  const [region, setRegion] = useState(inputData['AgentIndividualAddressInfoForm'] === undefined ? '' : inputData['AgentIndividualAddressInfoForm'].region);
  const [city, setCity] = useState(inputData['AgentIndividualAddressInfoForm'] === undefined ? '' : inputData['AgentIndividualAddressInfoForm'].city);
  const [address1, setAddress1] = useState(inputData['AgentIndividualAddressInfoForm'] === undefined ? '' : inputData['AgentIndividualAddressInfoForm'].address1);
  const [address2, setAddress2] = useState(inputData['AgentIndividualAddressInfoForm'] === undefined ? '' : inputData['AgentIndividualAddressInfoForm'].address2);
  const [errMessage, setErrMessage] = useState('');

  // 郵便番号変更イベント
  const handleChangePostalCode = (value) => {
    setPostalCode(value);
    axios
      .get('https://api.zipaddress.net/?zipcode=' + value)
      .then(res => {
        const success = res.data.code === 200;
        setRegion(prevState => success ? res.data.data.pref : prevState);
        setCity(prevState => success ? res.data.data.city : prevState);
        setAddress1(prevState => success ? res.data.data.town : prevState);
        setAddress2(prevState => success ? '' : prevState);
        setErrMessage({ ...errMessage, address1: success ? '番地以降をご入力ください' : '' });
      });
  };

  // ステップ移動時の処理
  const handleTransitionNext = () => {
    const json = { postalCode, region, city, address1, address2 };
    const [isErr, message] = validateInputs(json);
    setErrMessage([]);
    if (isErr) {
      setErrMessage(message);
      smoothScroll(Object.keys(message)[0]);
    }
    else {
      setInputData({ ...inputData, 'AgentIndividualAddressInfoForm': json });
      props.handleTransition('/others/agent/additionalcode');
    }
  };

  return (
    <Grid container spacing={3} alignItems='center' justifyContent='center' direction='column'>
      <Grid item alignItems='flex-start' style={{ width: '100%' }}>
        <p>権利者個人の住所をご入力ください。</p>
      </Grid>

      <Grid item style={{ width: '100%', textAlign: 'center' }}>
        <InputNumberBox
          id='postalCode'
          name='postalCode'
          label='郵便番号'
          placeholder='1234567'
          value={postalCode}
          onChange={handleChangePostalCode}
          errMessage={errMessage.postalCode}
          isUseHelperText={true}
          isUseNecessity={true}
          isRequired={true}
          dataTestId='postal-code'
        />
      </Grid>

      <Grid item style={{ width: '100%', textAlign: 'center' }}>
        <InputTextBox
          id='region'
          name='region'
          label='都道府県'
          placeholder='東京都'
          value={region}
          onChange={setRegion}
          errMessage={errMessage.region}
          isUseHelperText={true}
          isUseNecessity={true}
          isRequired={true}
          dataTestId='region'
        />
      </Grid>

      <Grid item style={{ width: '100%', textAlign: 'center' }}>
        <InputTextBox
          id='city'
          name='city'
          label='市区町村'
          placeholder='千代田区'
          value={city}
          onChange={setCity}
          errMessage={errMessage.city}
          isUseHelperText={true}
          isUseNecessity={true}
          isRequired={true}
          dataTestId='city'
        />
      </Grid>

      <Grid item style={{ width: '100%', textAlign: 'center' }}>
        <InputTextBox
          id='address1'
          name='address1'
          label='町域・番地'
          placeholder='〇〇町1丁目2番地の3'
          value={address1}
          onChange={setAddress1}
          errMessage={errMessage.address1}
          isUseHelperText={true}
          isUseNecessity={true}
          isRequired={true}
          dataTestId='address1'
        />
      </Grid>

      <Grid item style={{ width: '100%', textAlign: 'center' }}>
        <InputTextBox
          id='address2'
          name='address2'
          label='建物名など'
          placeholder='〇〇ビル'
          value={address2}
          onChange={setAddress2}
          isUseHelperText={false}
          isUseNecessity={true}
          isRequired={false}
          dataTestId='address2'
        />
      </Grid>

      <Grid item>
        <CustomButton
          label='次へ'
          variant='contained'
          onClick={handleTransitionNext}
        />
      </Grid>

      <Grid item>
        <CustomButton
          label='戻る'
          variant='text'
          onClick={() => props.handleTransition('/others/agent/individualbasicinfo')}
        />
      </Grid>
    </Grid>
  )
}

export default AgentIndividualAddressInfoForm